export default {
  forceVehicleSelectionLater: 'cm_force-vehicle-selection-later',
  garageData: 'cm_variant-garage',
  productsHistory: 'cm_productsHistory',
  deferedEvents: 'cm_deferedEvents',
  vehicle: 'cm_variant-model',
  view: 'cm_view',
  isLoggedIn: 'cm_is-logged-in',
  facetToggleField: (f: string): string => `cm_is-facet-toggled-${f}`,
  trackedThemeId: 'cm_tracked-theme-id',
  themeTelemetryEnabled: 'cm_theme-telemetry-enabled',
  searchId: 'cm_search-id',
  partsAdvisorThreadId: 'cm_parts-advisor-thread-id',
  partsAdvisorOpen: 'cm_parts-advisor-open', // Open state for the current tab session.
  partsAdvisorOpened: 'cm_parts-advisor-opened', // Has opened the advisor; hides the introductory launcher label.
};
